import React, { useState } from "react";
import Modal from "../../components/Modal";
import { ProductCard } from '../../components'
import WhatsAppButton from "../../components/WhatsAppButton";
import classNames from "classnames";
import classes from './banner.module.scss';
import { products } from "../../constants/layout";


const ProductShowcase = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleCloseDetails = () => setSelectedProduct(null);

   const handleOpenDetails = (product) => {
    setSelectedProduct(product);
  };


  return (
    <div className="mb-4 min-h-screen py-10">
      <div className=" max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onDetail={handleOpenDetails}
          />
        ))}
      </div>

      


      {selectedProduct && (
        <Modal open={!!selectedProduct} onClose={handleCloseDetails} title={selectedProduct.title}>
          <div className={classNames("flex overflow-x-auto gap-2 pb-2 border-none", classes.scrollbarHide)}>
            {selectedProduct.images.map((imgObj, idx) => (
              <div key={idx} className="flex-shrink-0 w-[15rem] ">
                <img
                  src={imgObj.src}
                  alt={`Product ${idx + 1}`}
                  className="w-[15rem] h-80 object-cover rounded-lg"
                />
                <p className="mt-2 text-base text-start text-gray-600 font-medium">{imgObj.description}</p>
              </div>
            ))}
          </div>
        </Modal>
      )}
      <WhatsAppButton />
    </div>
  );
};

export default ProductShowcase;
